import React from 'react'
import { useConfig } from 'msp-integrations'
import { BaseAccordionProps } from './Accordion.types'

const defaultAccordionProps: BaseAccordionProps = {
  wrapperStyles:
    'w-full max-w-lg mx-auto bg-white rounded border border-gray-201',
  children: '<div>Accordion items area</div>'
}

const BaseAccordion = ({
  wrapperStyles = defaultAccordionProps.wrapperStyles,
  children
}: BaseAccordionProps) => {
  const {
    theme: {
      font: { regular: font }
    }
  } = useConfig()

  return <div className={`${wrapperStyles} ${font}`}>{children}</div>
}

export default BaseAccordion
